import { inject, provideAppInitializer } from '@angular/core';

import { NotificationsHubClient } from './notifications-hub.client';

/**
 * Starts the notifications SignalR connection during app bootstrap.
 *
 * Register **after** `provideProfileInitializer()` so the auth cookie is known-valid;
 * profile init blocks bootstrap on 401 (the auth interceptor redirects to login),
 * which means we never try to start the hub for an unauthenticated user.
 *
 * Fire-and-forget: bootstrap proceeds immediately, the SignalR negotiate handshake
 * resolves in the background. Consumers should resync via REST if they miss the
 * first ~hundreds of milliseconds of events.
 */
export function provideNotificationsHub() {
  return provideAppInitializer(() => {
    const hubClient = inject(NotificationsHubClient);
    void hubClient.start();
  });
}
